module.exports = __webpack_public_path__ + "static/arc-logo-4fdad681d23b1176838956d6ae451cbf.svg";